/**
 * Newsletter Popup — Susmies
 * Modal con copy + formulario (Klaviyo embed) a la izquierda e imagen a la
 * derecha. Solo se abre al pulsar un elemento con [data-newsletter-popup-trigger]
 * (por ahora, el enlace "suscribes a nuestra Newsletter" en la PDP).
 *
 * El input/submit reales los inserta el merchant pegando el embed de Klaviyo
 * en el ajuste "klaviyo_embed".
 */
(function () {
  'use strict';

  const qs = (sel, root) => (root || document).querySelector(sel);
  const qsa = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  const getPopup = () => qs('[data-newsletter-popup]');
  const isEnabled = (popup) => popup && popup.dataset.enabled === 'true';

  // ------------------------------------------------------------------
  // Open / close
  // ------------------------------------------------------------------
  const openPopup = () => {
    const popup = getPopup();
    if (!popup || !isEnabled(popup)) return;
    if (popup.classList.contains('is-open')) return;
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('newsletter-popup-open');
    const focusable = popup.querySelector('input[type="email"], input, button:not([data-newsletter-popup-close])');
    if (focusable) {
      try { focusable.focus({ preventScroll: true }); } catch (_) { focusable.focus(); }
    }
  };

  const closePopup = () => {
    const popup = getPopup();
    if (!popup) return;
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('newsletter-popup-open');
  };

  // ------------------------------------------------------------------
  // Klaviyo integration — close popup when the embed reports a submit
  // ------------------------------------------------------------------
  const bindKlaviyo = () => {
    document.addEventListener('klaviyoForms', (event) => {
      const detail = event.detail || {};
      if (detail.type === 'submit') {
        setTimeout(closePopup, 1500);
      } else if (detail.type === 'close') {
        closePopup();
      }
    });
  };

  // ------------------------------------------------------------------
  // Bind events
  // ------------------------------------------------------------------
  const bindEvents = () => {
    qsa('[data-newsletter-popup-close]').forEach((el) => {
      el.addEventListener('click', closePopup);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      const popup = getPopup();
      if (popup && popup.classList.contains('is-open')) closePopup();
    });

    // Delegated manual triggers anywhere in the page (e.g. PDP newsletter link)
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest && e.target.closest('[data-newsletter-popup-trigger]');
      if (!trigger) return;
      e.preventDefault();
      openPopup();
    });

    // Fallback form (only used while no Klaviyo embed is configured) —
    // prevent submission and just show the success message visually.
    const fallback = qs('[data-newsletter-popup-fallback]');
    if (fallback) {
      fallback.addEventListener('submit', (e) => {
        e.preventDefault();
        const success = qs('[data-newsletter-popup-success]');
        if (success) {
          fallback.hidden = true;
          success.hidden = false;
        }
        setTimeout(closePopup, 1800);
      });
    }
  };

  // ------------------------------------------------------------------
  // Init
  // ------------------------------------------------------------------
  const init = () => {
    if (!getPopup()) return;
    bindEvents();
    bindKlaviyo();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target && e.target.querySelector('[data-newsletter-popup]')) {
      bindEvents();
    }
  });

  // Public testing API
  window.iuropNewsletterPopup = {
    show: openPopup,
    close: closePopup,
  };
})();
